module.exports = __webpack_public_path__ + "media/images/normas-ba_icon_48-365c54d589283e7816989f93965a4612.png";